const data = {
    meta: {
        name: 'Contact Us'
    },

    actions: {},

    form: {
        method: 'post',
        endpoint: '/connect/#thank-you'
    },

    layout: `
        <div id="ph-insert_post"></div>
        <div class="wrap">
            <div id="ph-first_name"></div>
            <div id="ph-last_name"></div>
            <div id="ph-email"></div>
            <div id="ph-country"></div>
        </div>
        <div id="ph-message"></div>
        <div id="ph-accepted_privacy"></div>
        <div class="form-actions">
            <div id="ph-controls"></div>
            <p class="form-help">* Indicates a required field.</p>
        </div>
        
    `,

    controls: [
        {type: 'submit', text: 'Send Now'}
    ],

    fields: [
        {
            type: 'Hidden',
            key: 'insert_post',
            value: 'lead'
        },
        {
            title: 'First Name',
            key: 'first_name',
            type: 'SmallText',
            validations: {
                required: true
            },
            strings: {
                placeholder: 'First Name *'
            }
        },
        {
            title: 'Last Name',
            key: 'last_name',
            type: 'SmallText',
            validations: {
                required: true
            },
            strings: {
                placeholder: 'Last Name *'

            }
        },
        {
            title: 'Email Address',
            key: 'email',
            type: 'Email',
            validations: {
                required: true
            },
            strings: {
                placeholder: 'Email Address *',
                helpText: 'We need an email address so we can write back to you.'

            },
            errorMessage: 'We need an email address'
        },
        {
            title: 'Country',
            key: 'country',
            type: 'SmallText',
            validations: {
                required: true
            },
            strings: {
                placeholder: 'Country of residence *'

            }
        },
        {
            title: 'Message',
            key: 'message',
            type: 'BigText',
            validations: {
                required: true
            },
            strings: {
                placeholder: `Your message *`
            },
            errorMessage: `We require this field to be filled out`
        },

        {
            key: 'accepted_privacy',
            type: 'Acceptance',
            validations: {
                required: true
            },
            dict: {
                title: `I have read and accept the <a target="_blank" href="/privacy-policy/">Privacy Policy.</a>`
            },
            checked: false,
            startValue: '1'
        }
    ]
};

export default class ContactSchema {
    constructor() {
        this._data = data;

        return this;
    }

    get data() {
        return this._data;
    }

    populate() {
    }
}
